import { MultimediaType } from '../../enums/multimedia-type';

export const isArchiveType = (type: MultimediaType): boolean => {
  return type === MultimediaType.Archive;
};
